import { render, staticRenderFns } from "./DeveloperCreate.vue?vue&type=template&id=89861078&"
import script from "./DeveloperCreate.vue?vue&type=script&lang=js&"
export * from "./DeveloperCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports